import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getSonarTaskTemplateConfig } from '@api';

export const coreSonarTaskConfigsByOrganizationIdAndTaskTypeGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreSonarTaskConfigsByOrganizationIdAndTaskType',
	receive: true,
	request: false,
	requestHandler: getSonarTaskTemplateConfig
});
